import { render, staticRenderFns } from "./img-portal.vue?vue&type=template&id=479b62bc&scoped=true&"
import script from "./img-portal.vue?vue&type=script&lang=js&"
export * from "./img-portal.vue?vue&type=script&lang=js&"
import style0 from "./img-portal.vue?vue&type=style&index=0&id=479b62bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479b62bc",
  null
  
)

export default component.exports